// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__oidke","rotation":"spinner_rotation__2zC4H"};